import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";
import Footer from "../../components/footer/component";
import ContactForm from "../../components/contact-form/component";

class ProjectOdd extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name: "",
            title: "",
            description: "",
            large: "",
            medium: "",
            small: "",
            logo_link: "",
            pitch_link: "",
            website_link: "",
            app_link: "",
            video_link: "",
            first_color: "",
            second_color: ""
        };
    };

    componentWillMount() {
        if(this.props.name){
            this.setState({name: this.props.name});
        }
        if(this.props.title){
            this.setState({title: this.props.title});
        }
        if(this.props.description){
            this.setState({description: this.props.description});
        }
        if(this.props.large){
            this.setState({large: this.props.large});
        }
        if(this.props.medium){
            this.setState({medium: this.props.medium});
        }
        if(this.props.small){
            this.setState({small: this.props.small});
        }
        if(this.props.logo_link){
            this.setState({logo_link: this.props.logo_link});
        }
        if(this.props.pitch_link){
            this.setState({pitch_link: this.props.pitch_link});
        }
        if(this.props.website_link){
            this.setState({website_link: this.props.website_link});
        }
        if(this.props.app_link){
            this.setState({app_link: this.props.app_link});
        }
        if(this.props.video_link){
            this.setState({video_link: this.props.video_link});
        }
        if(this.props.first_color){
            this.setState({first_color: this.props.first_color});
        }
        if(this.props.second_color){
            this.setState({second_color: this.props.second_color});
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _go(option){
        window.open(option, '_blank');
    }

    render() {
        return (
            <div className={Styles.sectionTwo}>
                <div className={Styles.sectionTwoBlock}>
                    <div style={{background: "linear-gradient(to right,"+this.state.first_color+", "+this.state.second_color+")"}} className={Styles.sectionTwoBlockDarkCover}>
                        <img style={{width: this.state.large}} className={Styles.sectionTwoBlockDarkCoverImageLarge} src={this.state.logo_link}/>
                        <img style={{width: this.state.medium}} className={Styles.sectionTwoBlockDarkCoverImageMedium} src={this.state.logo_link}/>
                        <img style={{width: this.state.small}} className={Styles.sectionTwoBlockDarkCoverImageSmall} src={this.state.logo_link}/>
                    </div>
                </div>
                <div className={Styles.sectionTwoBlock}>
                    <div className={Styles.sectionTwoBlockText}>
                        <div className={Styles.sectionTwoBlockTextName}>
                            {this.state.name}
                        </div>
                        <div className={Styles.sectionTwoBlockTextTitle}>
                            {this.state.title}
                        </div>
                        <div className={Styles.sectionTwoBlockTextSubtitle}>
                            {this.state.description}
                        </div>
                        <div className={Styles.sectionTwoBlockTextIconsContainer}>
                            {
                                this.state.pitch_link !== "" &&
                                <div onClick={() => this._go(this.state.pitch_link)} className={Styles.sectionTwoBlockTextIconsContainerItem}>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemButton}>
                                        <Icon.Download color={"#808080"}/>
                                    </div>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemTitle}>
                                        PITCH DECK
                                    </div>
                                </div>

                            }
                            {
                                this.state.app_link !== "" &&
                                <div onClick={() => this._go(this.state.app_link)} className={Styles.sectionTwoBlockTextIconsContainerItem}>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemButton}>
                                        <Icon.Smartphone color={"#808080"}/>
                                    </div>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemTitle}>
                                        APP
                                    </div>
                                </div>
                            }
                            {
                                this.state.website_link !== "" &&
                                <div onClick={() => this._go(this.state.website_link)} className={Styles.sectionTwoBlockTextIconsContainerItem}>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemButton}>
                                        <Icon.Monitor color={"#808080"}/>
                                    </div>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemTitle}>
                                        WEBSITE
                                    </div>
                                </div>

                            }
                            {
                                this.state.video_link !== "" &&
                                <div onClick={() => this._go(this.state.video_link)} className={Styles.sectionTwoBlockTextIconsContainerItem}>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemButton}>
                                        <Icon.Film color={"#808080"}/>
                                    </div>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemTitle}>
                                        VIDEO
                                    </div>
                                </div>

                            }
                            {
                                this.state.pitch_link === "" && this.state.app_link === "" && this.state.website_link === "" && this.state.video_link === "" &&
                                <div className={Styles.sectionTwoBlockTextIconsContainerItem}>
                                    <div className={Styles.sectionTwoBlockTextIconsContainerItemEmpty}>COMING SOON!</div>
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProjectOdd;


// WEBPACK FOOTER //
// ./src/components/project-odd/component.js